(ns manage.adset.view.page-wrapper
  (:require [manage.adset-deprecated-page.view :refer [adset-deprecated-page]]
            [manage.adset.hooks :as ah]
            [uix.core :refer [$ defui]]))

(defui adset-page-wrapper [{:keys [children]}]
  (let [{:keys [legacy]} (ah/use-adset)]
    (if legacy
      ($ adset-deprecated-page)
      children)))
